import React, { useEffect, useState } from "react";
import axios from "axios";
import "./eidMubarak.css";

const EidMubarak = () => {
  const [eidData, setEidData] = useState({
    title: "",
    description: "",
    image: "",
    key: "Secondary",
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchHeroData = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await axios.get(
          "https://api.generalhome.sa/api/Themes/GetSlider/Secondary"
        );

        if (response.data) {
          setEidData((prev) => ({
            ...prev,
            title: response.data.text1 || prev.title,
            description: response.data.text2 || prev.description,
            image: response.data.image || prev.image,
            key: response.data.Key || prev.key,
          }));
        }
      } catch (error) {
        console.error("Error fetching hero data:", error);
        setError("Failed to load hero content. Showing default content.");
      } finally {
        setLoading(false);
      }
    };

    fetchHeroData();
  }, []);

  return (
    <div
      className="eid"
      style={{
        backgroundImage: eidData.image ? `url(${eidData.image})` : "none",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="overlay"></div>
      <div className="eid-container container">
        <h1>{eidData.title}</h1>
        <p>{eidData.description}</p>
      </div>
    </div>
  );
};

export default EidMubarak;
